import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface SicknessState {}

const state = (): SicknessState => ({});

const mutations = {};

const getters = {};

const actions = {
  async createSicknessApplication({ commit }: { commit: Commit }, data: any) {
    const endpoint = "/application/sickness";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getSicknessTypes() {
    const endpoint = "/application/sickness/types";

    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
